import { render, staticRenderFns } from "./MobileCommunityBusinessnewsDetail.vue?vue&type=template&id=033bdbd7&scoped=true&"
import script from "./MobileCommunityBusinessnewsDetail.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityBusinessnewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunityBusinessnewsDetail.vue?vue&type=style&index=0&id=033bdbd7&scoped=true&lang=css&"
import style1 from "./MobileCommunityBusinessnewsDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033bdbd7",
  null
  
)

export default component.exports